import React from 'react';
const Footer = () => {
  return (
    <footer className="footer">
      Made by{' '}
      <a href="https://github.com/ParianshMahajan" target="_blank" rel="noopener noreferrer">
        Pariansh Mahajan
      </a>{' '}
      and{' '}
      <a href="https://github.com/kaurmanjot20" target="_blank" rel="noopener noreferrer">
        Manjot Kaur
      </a>
    </footer>
  );
};

export default Footer;
